import { createSlice } from '@reduxjs/toolkit';
import { TCompany } from 'types/companyType';

interface CompanyState {
  companies: TCompany[];
  companyDetail: TCompany | null;
}

const initialState: CompanyState = {
  companies: [],
  companyDetail: {} as TCompany,
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    getAllCompany(state, action) {
      state.companies = action.payload.results || [];
    },
  },
});

export const { getAllCompany } = companySlice.actions;
export default companySlice.reducer;
